module.exports = __webpack_public_path__ + "img/eye-young-complete.9142732a.jpg";